
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 14.4 14.4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.4 0c.22 0 .4.18.4.4V14a.4.4 0 01-.8 0V.4C0 .18.18 0 .4 0z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.76 8c.795 0 1.44.645 1.44 1.44v1.92a1.44 1.44 0 01-1.44 1.44H3.84a1.44 1.44 0 01-1.44-1.44V9.44C2.4 8.645 3.045 8 3.84 8h5.92zm-5.92.8a.64.64 0 00-.64.64v1.92c0 .354.287.64.64.64h5.92a.64.64 0 00.64-.64V9.44a.64.64 0 00-.64-.64H3.84zM12.96 1.6c.795 0 1.44.645 1.44 1.44v1.92a1.44 1.44 0 01-1.44 1.44H3.84A1.44 1.44 0 012.4 4.96V3.04c0-.795.645-1.44 1.44-1.44h9.12zm-9.12.8a.64.64 0 00-.64.64v1.92c0 .353.287.64.64.64h9.12a.64.64 0 00.64-.64V3.04a.64.64 0 00-.64-.64H3.84z","fill":"currentColor"}})])
          )
        }
      }
    